import { type Locale } from '@aps/contracts';

/**
 * Interfeys matnlari.
 *
 * Kontent (tovar nomi, tavsif) BU YERDA EMAS — u bazada `nameUz`/`nameRu`
 * ustunlarida (avtopart-i18n skill). Bu yerda faqat ilova matnlari.
 *
 * Ikkala tilda ham kalitlar bir xil bo'lishi SHART — `messages.spec.ts`
 * buni tekshiradi.
 */
const UZ = {
  'nav.home': 'Asosiy',
  'nav.catalog': 'Katalog',
  'nav.cart': 'Savat',
  'nav.orders': 'Buyurtmalar',
  'nav.profile': 'Profil',

  'home.searchPlaceholder': 'Qidirish... (masalan, filtr, tormoz, fara)',
  'home.categories': 'Kategoriyalar',
  'home.popular': 'Ommabop tovarlar',
  'home.activeOrder': 'Faol buyurtma',
  'home.bannerView': 'Ko‘rish',
  'help.section': 'Yordam va aloqa',
  'help.title': 'Yordam kerakmi?',
  'help.body': 'Detal tanlash yoki buyurtma bo‘yicha yordam beramiz',
  'help.write': 'Telegramda yozish',
  'help.orderTitle': 'Savolingiz bormi?',
  'help.orderBody': 'Yetkazib berish, detal mosligi yoki buyurtma holati bo‘yicha',
  'help.orderMessage': 'Salom! Buyurtma bo‘yicha savolim bor:',
  'help.fitTitle': 'Mos kelishiga ishonchingiz komil emasmi?',
  'help.fitBody': 'Avtomobilingizga mosligini aniqlashtiring',
  'help.fitMessage': 'Salom! Bu detal mashinamga mosmi:',
  'help.soonTitle': 'Narxi va muddatini aniqlang',
  'help.soonBody': 'Operator narx va kelish muddatini aytib beradi',
  'help.soonMessage': 'Salom! Narxi va kelish muddatini bilmoqchiman:',
  'success.title': 'Buyurtma qabul qilindi',
  'success.number': 'Raqam',
  'success.callback': "Operator 15 daqiqada qo'ng'iroq qilib, moslikni tekshiradi.",
  'success.nextStep': 'Keyingi qadam',
  'success.nextBody':
    "Tasdiqlangach botga karta raqami va aniq summa yuboriladi. O'tkazmadan keyin chek skrinshotini shu yerga tashlaysiz — operator tekshiradi va jo'natma tayyorlanadi.",
  'success.deliveryNote': "Yetkazish shartlari qo'ng'iroq paytida alohida kelishiladi.",
  'success.track': 'Holatni kuzatish',
  'success.continue': 'Xaridni davom ettirish',
  'home.forYourCar': 'Mashinangiz uchun',
  'home.garageEmpty': 'Mashinangizni qo‘shing',
  'home.garageHint': 'Sizga mos tovarlarni birinchi ko‘rsatamiz',

  'search.title': 'Qidiruv',
  'search.placeholder': 'Nima qidiryapsiz?',
  'search.correctedTo': 'Tuzatildi:',
  'search.empty': 'Hech narsa topilmadi',
  'search.emptyHint': 'Boshqacha yozib ko‘ring yoki katalogdan tanlang',
  'search.degraded': 'Qidiruv cheklangan rejimda ishlayapti',
  'search.resultCount': 'ta natija',

  'catalog.title': 'Katalog',
  'categories.title': 'Barcha kategoriyalar',
  'categories.all': 'Hammasi',
  'catalog.empty': 'Bu bo‘limda hozircha tovar yo‘q',
  'catalog.all': 'Barchasi',
  'catalog.more': 'Yana ko‘rsatish',
  'catalog.sortAsc': 'Arzonroq',
  'catalog.sortDesc': 'Qimmatroq',

  'product.addToCart': 'Savatga',
  'product.inCart': 'Savatda',
  'product.oem': 'Artikul',
  'product.description': 'Tavsif',
  'product.sku': 'Artikul',
  'product.brand': 'Brend',
  'product.fits': 'Qaysi mashinalarga',
  'product.addToCartLong': 'Savatga qo‘shish',
  'product.buyNow': 'Hozir buyurtma berish',
  'product.badgeHere': 'Mavjud',
  'product.badgePreOrder': 'Buyurtma asosida',

  'cart.title': 'Savat',
  'cart.empty': 'Savat bo‘sh',
  'cart.emptyHint': 'Katalogdan tovar tanlang',
  'cart.total': 'Jami',
  'cart.checkout': 'Rasmiylashtirish',
  'cart.clear': 'Tozalash',

  'checkout.title': 'Rasmiylashtirish',
  'checkout.contact': 'Aloqa',
  'checkout.name': 'Ismingiz',
  'checkout.useTelegramPhone': 'Telegram raqamimni ishlatish',
  'checkout.phoneShared': 'Raqam olindi',
  'checkout.phoneDenied': 'Raqam ulashilmadi — qo‘lda yozing',
  'checkout.delivery': 'Yetkazish',
  'checkout.courier': 'Yetkazib berish',
  'checkout.pickup': 'Do‘kondan olib ketaman',
  'checkout.region': 'Hududni tanlang',
  'checkout.address': 'Manzil',
  'checkout.splitTitle': 'Qanday yuboraylik?',
  'checkout.splitHint': 'Bir qism tovar {days} kunda keladi',
  'checkout.splitSeparate': 'Alohida yuboring',
  'checkout.splitSeparateHint': 'Tayyorini ertaga oling',
  'checkout.splitTogether': 'Birga yuboring',
  'checkout.splitTogetherHint': 'Hammasi bitta jo‘natmada',
  'checkout.submit': 'Buyurtma berish',

  'orders.title': 'Buyurtmalarim',
  'orders.empty': 'Hozircha buyurtma yo‘q',
  'orders.emptyHint': 'Birinchi buyurtmangizni bering',
  'orders.number': 'Buyurtma',
  'orders.items': 'ta tovar',

  'order.title': 'Buyurtma',
  'order.shipments': 'Jo‘natmalar',
  'order.contact': 'Aloqa',
  'order.payment': 'To‘lov',
  'order.paymentUnpaid': 'To‘lanmagan',
  'order.paymentPartial': 'Qisman to‘langan',
  'order.paymentPaid': 'To‘langan',
  'order.paymentOverpaid': 'Ortiqcha to‘langan',
  'order.operatorNote': 'Operator izohi',

  'shipment.title': 'Jo‘natma',
  'shipment.history': 'Tarix',
  'shipment.items': 'Tarkibi',

  'garage.title': 'Garaj',
  'garage.empty': 'Garaj bo‘sh',
  'garage.emptyHint': 'Mashinangizni qo‘shsangiz, mos tovarlarni birinchi ko‘rsatamiz',
  'garage.add': 'Mashina qo‘shish',
  'garage.make': 'Marka',
  'garage.model': 'Model',
  'garage.year': 'Yil',
  'garage.setActive': 'Faol qilish',
  'garage.remove': 'O‘chirish',

  'profile.title': 'Profil',
  'profile.language': 'Til',
  'profile.theme': 'Mavzu',
  'profile.themeDark': 'Qorong‘i',
  'profile.themeLight': 'Yorug‘',
  'profile.themeRace': 'Poyga',
  'profile.garage': 'Garaj',

  'common.retry': 'Qayta urinish',
  'common.loading': 'Yuklanmoqda',
  'common.error': 'Xatolik yuz berdi',
  'common.back': 'Orqaga',
  'toast.addedToCart': 'Savatga qo‘shildi',
  'toast.openCart': 'Savatga o‘tish',
  'toast.cartCleared': 'Savat tozalandi',
  'toast.orderCreated': 'Buyurtma yaratildi — kuzatuvda ko‘ring',
  'toast.garageSaved': 'Mashina saqlandi',
  'toast.garageCleared': 'Garaj tozalandi',
  'toast.failed': 'Bajarilmadi',
  'guest.title': 'Telegram orqali oching',
  'guest.hint':
    'Buyurtma berish uchun ilova Telegram ichida ochilishi kerak. Katalogni shu yerda ham ko‘rishingiz mumkin.',
  'home.viewAll': 'Barchasini ko‘rish',
  'home.otherCategories': 'Boshqalar',
  'card.addToCart': 'Savatga qo‘shish',
} as const;

const RU: Record<keyof typeof UZ, string> = {
  'nav.home': 'Главная',
  'nav.catalog': 'Каталог',
  'nav.cart': 'Корзина',
  'nav.orders': 'Заказы',
  'nav.profile': 'Профиль',

  'home.searchPlaceholder': 'Поиск... (например, фильтр, тормоз, фара)',
  'home.categories': 'Категории',
  'home.popular': 'Популярные товары',
  'home.activeOrder': 'Активный заказ',
  'home.bannerView': 'Смотреть',
  'help.section': 'Помощь и связь',
  'help.title': 'Нужна помощь?',
  'help.body': 'Поможем подобрать деталь или с заказом',
  'help.write': 'Написать в Telegram',
  'help.orderTitle': 'Остались вопросы?',
  'help.orderBody': 'По доставке, совместимости детали или статусу заказа',
  'help.orderMessage': 'Здравствуйте! У меня вопрос по заказу:',
  'help.fitTitle': 'Не уверены, что подойдёт?',
  'help.fitBody': 'Уточните совместимость с вашим автомобилем',
  'help.fitMessage': 'Здравствуйте! Подойдёт ли эта деталь к моей машине:',
  'help.soonTitle': 'Уточните цену и срок',
  'help.soonBody': 'Оператор назовёт цену и срок поставки',
  'help.soonMessage': 'Здравствуйте! Хочу узнать цену и срок поставки:',
  'success.title': 'Заказ принят',
  'success.number': 'Номер',
  'success.callback': 'Оператор перезвонит в течение 15 минут и проверит совместимость.',
  'success.nextStep': 'Следующий шаг',
  'success.nextBody':
    'После подтверждения бот пришлёт номер карты и точную сумму. После перевода отправьте сюда скриншот чека — оператор проверит и отправление будет собрано.',
  'success.deliveryNote': 'Условия доставки обсуждаются отдельно во время звонка.',
  'success.track': 'Отследить статус',
  'success.continue': 'Продолжить покупки',
  'home.forYourCar': 'Для вашей машины',
  'home.garageEmpty': 'Добавьте свой автомобиль',
  'home.garageHint': 'Покажем подходящие товары первыми',

  'search.title': 'Поиск',
  'search.placeholder': 'Что вы ищете?',
  'search.correctedTo': 'Исправлено:',
  'search.empty': 'Ничего не найдено',
  'search.emptyHint': 'Попробуйте написать иначе или выберите из каталога',
  'search.degraded': 'Поиск работает в ограниченном режиме',
  'search.resultCount': 'результатов',

  'catalog.title': 'Каталог',
  'categories.title': 'Все категории',
  'categories.all': 'Все',
  'catalog.empty': 'В этом разделе пока нет товаров',
  'catalog.all': 'Все',
  'catalog.more': 'Показать ещё',
  'catalog.sortAsc': 'Дешевле',
  'catalog.sortDesc': 'Дороже',

  'product.addToCart': 'В корзину',
  'product.inCart': 'В корзине',
  'product.oem': 'Артикул',
  'product.description': 'Описание',
  'product.sku': 'Артикул',
  'product.brand': 'Бренд',
  'product.fits': 'Для каких автомобилей',
  'product.addToCartLong': 'Добавить в корзину',
  'product.buyNow': 'Оформить сейчас',
  'product.badgeHere': 'В наличии',
  'product.badgePreOrder': 'Под заказ',

  'cart.title': 'Корзина',
  'cart.empty': 'Корзина пуста',
  'cart.emptyHint': 'Выберите товар из каталога',
  'cart.total': 'Итого',
  'cart.checkout': 'Оформить',
  'cart.clear': 'Очистить',

  'checkout.title': 'Оформление',
  'checkout.contact': 'Контакты',
  'checkout.name': 'Ваше имя',
  'checkout.useTelegramPhone': 'Использовать номер из Telegram',
  'checkout.phoneShared': 'Номер получен',
  'checkout.phoneDenied': 'Номер не передан — введите вручную',
  'checkout.delivery': 'Доставка',
  'checkout.courier': 'Доставить',
  'checkout.pickup': 'Заберу из магазина',
  'checkout.region': 'Выберите регион',
  'checkout.address': 'Адрес',
  'checkout.splitTitle': 'Как отправить?',
  'checkout.splitHint': 'Часть товаров приедет через {days} дней',
  'checkout.splitSeparate': 'Отправьте отдельно',
  'checkout.splitSeparateHint': 'Готовое получите завтра',
  'checkout.splitTogether': 'Отправьте вместе',
  'checkout.splitTogetherHint': 'Всё одной отправкой',
  'checkout.submit': 'Заказать',

  'orders.title': 'Мои заказы',
  'orders.empty': 'Заказов пока нет',
  'orders.emptyHint': 'Сделайте первый заказ',
  'orders.number': 'Заказ',
  'orders.items': 'товаров',

  'order.title': 'Заказ',
  'order.shipments': 'Отправления',
  'order.contact': 'Контакты',
  'order.payment': 'Оплата',
  'order.paymentUnpaid': 'Не оплачен',
  'order.paymentPartial': 'Частично оплачен',
  'order.paymentPaid': 'Оплачен',
  'order.paymentOverpaid': 'Переплата',
  'order.operatorNote': 'Комментарий оператора',

  'shipment.title': 'Отправление',
  'shipment.history': 'История',
  'shipment.items': 'Состав',

  'garage.title': 'Гараж',
  'garage.empty': 'Гараж пуст',
  'garage.emptyHint': 'Добавьте автомобиль — покажем подходящие товары первыми',
  'garage.add': 'Добавить автомобиль',
  'garage.make': 'Марка',
  'garage.model': 'Модель',
  'garage.year': 'Год',
  'garage.setActive': 'Сделать активным',
  'garage.remove': 'Удалить',

  'profile.title': 'Профиль',
  'profile.language': 'Язык',
  'profile.theme': 'Тема',
  'profile.themeDark': 'Тёмная',
  'profile.themeLight': 'Светлая',
  'profile.themeRace': 'Гонка',
  'profile.garage': 'Гараж',

  'common.retry': 'Повторить',
  'common.loading': 'Загрузка',
  'common.error': 'Произошла ошибка',
  'common.back': 'Назад',
  'toast.addedToCart': 'Добавлено в корзину',
  'toast.openCart': 'В корзину',
  'toast.cartCleared': 'Корзина очищена',
  'toast.orderCreated': 'Заказ создан — смотрите в отслеживании',
  'toast.garageSaved': 'Машина сохранена',
  'toast.garageCleared': 'Гараж очищен',
  'toast.failed': 'Не выполнено',
  'guest.title': 'Откройте через Telegram',
  'guest.hint':
    'Для заказа приложение должно быть открыто внутри Telegram. Каталог можно смотреть и здесь.',
  'home.viewAll': 'Смотреть все',
  'home.otherCategories': 'Прочее',
  'card.addToCart': 'Добавить в корзину',
};

export type MessageKey = keyof typeof UZ;

export const MESSAGES: Readonly<Record<Locale, Readonly<Record<MessageKey, string>>>> = {
  UZ,
  RU,
};

/** Tarjima. Kalit topilmasa KALITNING O'ZI qaytadi — bo'sh joy emas. */
export function translate(locale: Locale, key: MessageKey): string {
  return MESSAGES[locale][key];
}
